export default __webpack_public_path__ + "static/media/V124_RoHS.7ea2e4cd.pdf";